module.exports = __webpack_public_path__ + "img/300_300_default_profile.1b8d36fd.png";